<div
  class="session-details-container flex flex-col w-full min-h-full space-y-[3.2rem] pb-[2rem]"
>
  <div class="flex flex-col w-full">
    <app-heading-loader *ngIf="loading; else showHeading"/>
    <ng-template #showHeading>
      <div class="heading-container w-full flex flex-row justify-between">
        <div
          class="flex flex-row w-[calc(100%-15rem)] md:w-[60%] space-x-[1rem] justify-start items-center">
          <div class="heading">Session {{ params?.sessionId }}</div>
          <div class="date-time">{{ sessionDetails?.sessionStartDate | date:'MMM dd. yyyy, hh:mm a' }}</div>
        </div>
        <div
          class="flex flex-col md:flex-row w-[15rem] md:w-[40%] justify-end items-center space-x-[1rem]">
          <span class="group-status-label">Group Status:</span>
          <div
            *ngIf="groupStatus"
            class="group-status"
            [ngStyle]="{
              'background-color': groupStatusColors[groupStatus]
            }"
          >
            {{ groupDetails?.statusName }}
          </div>
<!--          <app-primary-button-->
<!--            (handleClick)="closeSession()"-->
<!--            *ngIf="!sessionDetails?.isComplete && (groupStatus != 1 && groupStatus != 4)"-->
<!--            class="save-btn xs:w-full sm:w-full md:w-[60%] lg:w-[40%]"-->
<!--            type="small"-->
<!--          >-->
<!--            Close Session-->
<!--          </app-primary-button>-->
<!--          <app-primary-button-->
<!--            (handleClick)="restartSession()"-->
<!--            *ngIf="sessionDetails?.isComplete"-->
<!--            class="save-btn xs:w-full sm:w-full md:w-[60%] lg:w-[40%]"-->
<!--            type="small"-->
<!--          >-->
<!--            Restart Session-->
<!--          </app-primary-button>-->
        </div>
      </div>
    </ng-template>

    <hr class="line mt-[0.8rem]">
  </div>

  <app-food-journaling-loader *ngIf="loading; else showFoodJournaling"/>
  <ng-template #showFoodJournaling>
    <div class="title-section">
      <mat-expansion-panel
        [expanded]="true"
        class="mat-elevation-z0 expansion-panel w-full">
        <mat-expansion-panel-header class="bg-black-100 expansion-panel-header justify-center">
          <div class="title text-cool-grey font-poppins font-semibold text-[1.6rem]">
            {{ sessionDetails?.name }}
          </div>
        </mat-expansion-panel-header>
        <div class="description">
          {{ sessionDetails?.description }}
        </div>
        <hr class="inner-line mt-[1rem]">
      </mat-expansion-panel>
    </div>
  </ng-template>

  <app-schedule-loader *ngIf="loading; else showSchedule"/>
  <ng-template #showSchedule>
    <div class="details-section">
      <mat-expansion-panel
        [expanded]="true"
        class="mat-elevation-z0 expansion-panel w-full">
        <mat-expansion-panel-header class="bg-black-100 expansion-panel-header justify-center">
          <div class="title text-cool-grey font-poppins font-semibold text-[1.6rem]">
            Schedule
          </div>
        </mat-expansion-panel-header>
        <form class="schedule-details flex flex-col w-full space-y-[1rem] lg:px-[8rem] xs:px-0 sm:px-0 pt-[3.2rem]">
          <div
            class="flex lg:flex-row w-full justify-center items-center lg:space-x-[1.5rem] xs:space-x-0 sm:space-x-0 xs:flex-col sm:flex-col">
            <app-date-picker
              (checkForErrors)="checkForErrors($event)"
              [error]="errorMessages['sessionStartDate']"
              [max]="maxDate"
              [min]="minDate"
              [parentFormGroup]="form"
              class="input lg:w-[30%] xs:w-full sm:w-full"
              controlName="sessionStartDate"
              label="Session Start Date"
              placeholder="Select a date"
              type="small"
            >
            </app-date-picker>
            <app-time-picker
              (checkForErrors)="checkForErrors($event)"
              [error]="errorMessages['startTime']"
              [parentFormGroup]="form"
              class="input lg:w-[18%] xs:w-full sm:w-full"
              controlName="startTime"
              label="Start Time"
              placeholder="Select time"
              type="small"
            ></app-time-picker>
            <app-dropdown
              (checkForErrors)="checkForErrors($event)"
              [error]="errorMessages['sessionFormat']"
              [options]="sessionFormatOptions"
              [parentFormGroup]="form"
              class="input lg:w-[17%] min-w-[17%] xs:w-full sm:w-full"
              controlName="sessionFormat"
              label="Session Format"
              placeholder="Select one"
              type="small"
            />
            <div class="flex lg:flex-row lg:w-[35%] space-x-[1.5rem] xs:w-full sm:w-full">
              <app-dropdown
                (checkForErrors)="checkForErrors($event)"
                [error]="errorMessages['sessionDelivery']"
                [options]="sessionDeliveryOptions"
                [parentFormGroup]="form"
                class="input w-[50%] min-w-[50%]"
                controlName="sessionDelivery"
                label="Session Delivery"
                placeholder="Select one"
                type="small"
              />
              <app-number-input
                (checkForErrors)="checkForErrors($event)"
                [error]="errorMessages['duration']"
                [max]="999"
                [parentFormGroup]="form"
                class="input w-[50%]"
                controlName="duration"
                label="Duration"
                suffixText="Mins"
                type="small"
              ></app-number-input>
            </div>
          </div>

          <div class="flex flex-col justify-start">
            <div class="label">
              Coaches
            </div>
            <div class="coaches flex md:flex-row w-full xs:flex-col sm:flex-col">
              <mat-checkbox
                (change)="onCoachSelectionChange(option)"
                *ngFor="let option of coachesOptions"
                [checked]="option.checked"
                [disabled]="isCoachSelectionDisabled && !option.checked || sessionDetails?.isComplete || groupStatus !== 2"
                aria-label="Select an option"
                class="checkbox small"
              >
                {{ option.value }}
              </mat-checkbox>
              <mat-checkbox
                (change)="onSelectOtherCoaches($event)"
                [checked]="isOtherCoachSelectionEnabled"
                [disabled]="sessionDetails?.isComplete || groupStatus !== 2"
                class="checkbox small">
                {{ 'Other' }}
              </mat-checkbox>
            </div>
          </div>
          <div
            class="other-coaches flex w-full justify-start items-center">
            <app-dropdown
              (checkForErrors)="checkForErrors($event)"
              [enableClearSelection]="true"
              [enableMultiple]="true"
              [error]="errorMessages['otherCoaches']"
              [loading]="otherCoachesOptionsLoading"
              [options]="otherCoachesOptions"
              [parentFormGroup]="form"
              class="input lg:w-[40%] xs:w-full sm:w-full mt-[1rem]"
              controlName="otherCoaches"
              label="Choose Coach"
              placeholder="Select Coaches"
              type="small"
            />
          </div>
          <div class="row flex flex-row w-full">
            <app-text-area-input
              (checkForErrors)="checkForErrors($event)"
              [error]="errorMessages['notes']"
              [parentFormGroup]="form"
              class="input w-full"
              controlName="notes"
              label="Encounter Summary Notes"
              placeholder="Enter Encounter Summary Notes about this session (optional)"
              type="small"
            ></app-text-area-input>
          </div>
          <div class="flex w-full justify-end mt-[2rem]">
            <app-primary-button
              (handleClick)="onSaveSchedule()"
              [isDisabled]="sessionDetails?.isComplete || !form.dirty || groupStatus !== 2"
              class="save-btn xs:w-[30%] sm:w-[25%] md:w-[15%]"
              type="small"
            >
              Save
            </app-primary-button>
          </div>
        </form>
        <hr class="inner-line mt-[1rem]">

      </mat-expansion-panel>
    </div>
  </ng-template>

  <div class="attendance-section">
    <mat-expansion-panel
      [expanded]="true"
      class="mat-elevation-z0 expansion-panel w-full">
      <mat-expansion-panel-header class="bg-black-100 expansion-panel-header justify-center">
        <div class="title text-cool-grey font-poppins font-semibold text-[1.6rem]">
          Attendance
        </div>
      </mat-expansion-panel-header>
      <div class="w-full flex flex-col">
        <div class="w-full max-h-[52rem] overflow-auto">
          <table
            [dataSource]="dataSource"
            mat-table
          >
            <!--    PARTICIPANTS-->
            <ng-container
              [sticky]="true"
              matColumnDef="participantName"
            >
              <th
                *matHeaderCellDef
                class="md:min-w-[5rem] xs:min-w-[20rem] sm:min-w-[20rem]"
                mat-header-cell
              >
                <div class="th-cell">
                  Participant
                </div>
              </th>
              <td *matCellDef="let eachRow"
                  mat-cell>
                <div class="td-cell">
                  {{ eachRow?.name }}
                </div>
              </td>
            </ng-container>
            <!--    RADIO BUTTONS-->
            <ng-container matColumnDef="present">
              <th
                *matHeaderCellDef
                class="min-w-[5rem] w-[5rem]"
                mat-header-cell
              >
                <div class="th-cell space-x-[1.5rem]">
                  <div matTooltip="Attended"
                       matTooltipPosition="above">Yes
                  </div>
                  <div matTooltip="Absent"
                       matTooltipPosition="above">No
                  </div>
                </div>
              </th>
              <td *matCellDef="let eachRow"
                  mat-cell>
                <div *ngIf="eachRow.participantGroupStatus !== 4"
                     class="td-cell xs:min-w-[10rem] xs:w-[12rem] sm:min-w-[10rem] sm:w-[12rem]">
                  <form [formGroup]="attendanceFormGroup">
                    <mat-radio-group
                      *ngIf="attendanceFormGroup.controls[''+eachRow.id]"
                      [formControlName]="''+eachRow.id">
                      <mat-radio-button
                        [disabled]="groupStatus !== 2 || eachRow?.participantStatus?.key === 1 || eachRow?.participantStatus?.key === 4 || sessionDetails?.isComplete ? true : false"
                        [value]="1"
                        class="present-radio-btn">
                      </mat-radio-button>
                      <mat-radio-button
                        [disabled]="groupStatus !== 2 || eachRow?.participantStatus?.key === 1 || eachRow?.participantStatus?.key === 4 || sessionDetails?.isComplete ? true : false"
                        [value]="2"
                        class="absent-radio-btn">
                      </mat-radio-button>
                    </mat-radio-group>
                  </form>
                </div>
              </td>
            </ng-container>
            <!--    ADULTS-->
            <ng-container matColumnDef="adultsName">
              <th
                *matHeaderCellDef
                class="min-w-[30rem]"
                mat-header-cell
              >
                <div class="th-cell">
                  Adults
                </div>
              </th>
              <td *matCellDef="let eachRow"
                  mat-cell>
                <div *ngIf="eachRow.participantGroupStatus !== 4" class="td-cell">
                  {{ eachRow.adultsName }}
                </div>
              </td>
            </ng-container>
            <!--    CLICKABLE TEXT-->
            <ng-container [sticky]="true"
                          matColumnDef="sessionDetails"
            >
              <th
                *matHeaderCellDef
                class="min-w-[10rem]"
                mat-header-cell
              >
                <div class="th-cell">

                </div>
              </th>
              <td *matCellDef="let eachRow"
                  mat-cell>
                <div class="td-cell">
                  <div
                    (click)="onSessionDetailsClicked(eachRow)"
                    *ngIf="groupStatus === 1 || eachRow?.participantStatus?.key === 1 ? false : true"
                    class="clickable session-details-clickable-text"
                  >
                    {{ eachRow.sessionDetails }}
                  </div>
                </div>
              </td>
            </ng-container>
            <!--    ACTION MENU-->
            <ng-container matColumnDef="actions">
              <th
                *matHeaderCellDef
                mat-header-cell
              >
              </th>
              <td *matCellDef="let eachRow; let index=index"
                  class="w-[5rem]"
                  mat-cell>
                <button
                  [matMenuTriggerFor]="menu"
                  mat-icon-button
                >
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button
                    *ngIf="eachRow.isPresent !== null"
                    (click)="deleteAttendance(eachRow, index)"
                    mat-menu-item
                  >
                    <span class=" ">Delete Attendance</span>
                  </button>
                  <button
                    *ngIf="eachRow?.participantGroupStatus !== 3"
                    (click)="markDropOut(eachRow)"
                    mat-menu-item
                  >
                    <span class=" ">Mark Inactive</span>
                  </button>
                  <button
                    *ngIf="eachRow?.participantGroupStatus === 3"
                    (click)="markParticipantAsActive(eachRow)"
                    mat-menu-item
                  >
                    <span class=" ">Mark as Active</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>

            <tr *matHeaderRowDef="displayedColumns; sticky: true"
                mat-header-row></tr>
            <tr *matRowDef="let row; columns: displayedColumns;"
                mat-row></tr>

          </table>
          <div
            *ngIf="loading"
            class="loading-section"
          >
            <mat-spinner
              [diameter]="100"
              mode="indeterminate"
              strokeWidth="5"
            >
            </mat-spinner>
          </div>
          <div
            *ngIf="!loading && !dataSource?.length"
            class="no-data flex flex-col justify-center items-center"
          >
            <div class="text">
              'No data available'
            </div>
          </div>
        </div>

        <div class="flex w-full justify-end mt-[2rem]">
          <app-primary-button
            (handleClick)="onSaveAttendance()"
            [isDisabled]="sessionDetails?.isComplete || !attendanceFormGroup.dirty || groupStatus != 2"
            [isLoading]="markAttendanceLoading"
            class="save-btn xs:w-[30%] sm:w-[40%] md:w-[20%] lg:w-[15%]"
            type="small"
          >
            Save
          </app-primary-button>
        </div>
      </div>
    </mat-expansion-panel>
  </div>

  <div class="resources-section">
    <mat-expansion-panel
      [expanded]="true"
      class="mat-elevation-z0 expansion-panel w-full">
      <mat-expansion-panel-header class="bg-black-100 expansion-panel-header justify-center">
        <div class="title text-cool-grey font-poppins font-semibold text-[1.6rem]">
          Resources
        </div>
      </mat-expansion-panel-header>
      <div
        class="h-[55rem] relative w-full"
      >
        <div
          (scrolled)="onScroll()"
          *ngIf="resourceData?.list?.length"
          [class.loading]="resourceData?.loading"
          [infiniteScrollDistance]="2"
          [infiniteScrollThrottle]="10"
          [scrollWindow]="false"
          class="resources h-full w-full flex flex-row flex-wrap"
          infiniteScroll
        >
          <app-session-resources
            *ngFor="let resource of resourceData?.list"
            [data]="resource"
            class="session-resource flex xs:w-[50%] sm:w-[50%] md:w-[33%] lg:w-[25%]"
          >
          </app-session-resources>
        </div>
        <div
          *ngIf="!resourceData?.list?.length && !resourceData?.loading"
          class="no-data flex flex-col justify-center items-center">
          <div class="text">
            'No data available'
          </div>
        </div>
        <div
          *ngIf="resourceData?.loading"
          class="resources-loading-section w-full h-full flex justify-center items-center"
        >
          <mat-spinner
            [diameter]="100"
            mode="indeterminate"
            strokeWidth="5"
          />
        </div>
      </div>
    </mat-expansion-panel>
  </div>
</div>
